import {useEffect, useState} from 'react';
import TextField from "../../fragments/form/TextField"
import CheckboxSelector from "../../fragments/form/CheckboxSelector"
import SubmitButton from "../../fragments/form/SubmitButton"


const EditStateForm = (props) => {
    const [formData, setFormData] = useState(new FormData());

    const onChange = (id, value) => {
        formData.set(id, value);
        setFormData(formData);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(formData);
    }
   
    return (
        <form onSubmit={onSubmit}>
            <TextField id="state" required={true} value={props.state.state} onChange={onChange} label="Name" />
            <CheckboxSelector id="is_published" value={props.state.is_published} onChange={onChange} label="Publish" />
            <SubmitButton />
        </form>
    );
}

export default EditStateForm;
